<template>
  <div class="appHeader">
    <div class="appHeader__logo">
      <router-link :to="{ name: 'home' }">
        <img
          class="appHeader__logo--desktop"
          src="@/assets/images/layout/logo-blanc.png"
        >
        <img
          class="appHeader__logo--mobile"
          src="@/assets/images/logo.png"
        >
      </router-link>
    </div>
    <auth-nav />
  </div>
</template>

<script>
import AuthNav from '@/components/layout/AuthNav'

export default {
  name: 'Header',
  components: {
    AuthNav
  }
}
</script>

<style lang="scss" scoped>
$c: '.appHeader';

#{$c} {
  position: relative;
  height: 101px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  z-index: 98;
  font-size: 18px;
  padding: 0 30px;
  margin-bottom: 20px;

  @include respond-below(sm) {
    padding: 0;
    height: 60px;
  }

  &__title {
    font-size: 17px;
    font-weight: 600;
    line-height: 20px;
    padding-left: 50px;
    @include respond-below(lg) {
      display: none;
    }
  }

  &__logo {
    display: flex;
    align-items: center;
    justify-content: center;

    & img {
      height: 115px;
      width: auto;
      @include respond-below(md) {
        height: 60px;
      }
    }

    &--desktop {
      @include respond-below(md) {
        display: none;
      }
    }
    &--mobile {
      display: none;
      @include respond-below(md) {
        display: block;
      }
    }
  }

  &__navigation {
    @include respond-below(lg) {
      flex: 100% 0;
      justify-content: center;
      margin-top: -8rem;
    }

    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>